import React from "react";
import styled from "styled-components";

export default styled.h2`
    font-size: 21px;
    line-height: 25px;
    color: white;
    position: absolute;
    top: -55px;
    z-index: 3;
`;